import React from "react";
import { Table } from "reactstrap";

const TimetableTab = ({
    selectedDay,
    setSelectedDay,
    loadingTimetable,
    filteredTimetable,
    openAddModal,
    teachers
}) => {
    return (
        <div>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                <h5 className="fw-bold mb-0">Timetable</h5>
                <button
                    className="btn btn-danger fw-semibold px-3 py-2 shadow-sm"
                    onClick={openAddModal}
                >
                    + Edit/Add Day Timetable
                </button>
            </div>

            {/* Weekday Filter */}
            <div
                className="d-flex justify-content-start align-items-center mb-4 flex-wrap"
                style={{ gap: "8px" }}
            >
                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday","Saturday","Sunday"].map((day) => (
                    <button
                        key={day}
                        className="btn fw-semibold"
                        onClick={() => setSelectedDay(day)}
                        style={{
                            backgroundColor: selectedDay === day ? "#E94057" : "transparent",
                            color: selectedDay === day ? "#fff" : "#E94057",
                            border: "2px solid #E94057",
                            borderRadius: "10px",
                            padding: "6px 14px",
                            transition: "all 0.2s ease-in-out",
                        }}
                        onMouseEnter={(e) => {
                            if (selectedDay !== day) e.target.style.backgroundColor = "#fce4ec";
                        }}
                        onMouseLeave={(e) => {
                            if (selectedDay !== day) e.target.style.backgroundColor = "transparent";
                        }}
                    >
                        {day}
                    </button>
                ))}
            </div>

            {/* Table */}
            {loadingTimetable ? (
                <div className="text-center py-4">
                    <div className="spinner-border text-danger" role="status" />
                    <p className="mt-2 text-muted">Loading timetable...</p>
                </div>
            ) : filteredTimetable.length === 0 ? (
                <div className="text-center text-muted py-4">
                    No timetable entries found for {selectedDay || "this week"}.
                </div>
            ) : (
                <Table bordered hover responsive>
                    <thead className="table-light">
                        <tr>
                            <th>Day</th>
                            <th>Subject</th>
                            <th>Teacher</th>
                            <th>Start</th>
                            <th>End</th>
                            <th>Remarks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTimetable.map((item, idx) => (
                            <tr key={idx}>
                                <td>{item.day_of_week}</td>
                                <td>{item.subject_name}</td>
                                <td>
                                    {
                                        teachers.find(
                                            (t) => String(t.value).trim() === String(item.teacher_uuid).trim()
                                        )?.label || "Unknown"
                                    }
                                </td>


                                <td>{item.start_time}</td>
                                <td>{item.end_time}</td>
                                <td>{item.remarks || "-"}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default TimetableTab;
